import { action, observable } from 'mobx'

export default class MessengerStore {
  @observable currentMessage = null
  @observable open = false

  @observable messages = {
   CHANGED_PASSWORD:'changedPassword',
   ERR_CHANGE_PASSWORD:'errChangePassword',
   CHANGED_MAIL:'changedMail',
   ERR_CHANGE_MAIL:'errChangeMail',
   SUGGESTION_SUCCESS:'suggestionSuccess',
   SUGGESTION_DECLINED:'suggestionDeclined',
   SUGGESTION_ACCEPTED:'suggestionAccepted',
   SUGGESTION_PAYLOAD_INCOMPLETE:'suggestionPayloadIncomplete',
   ITEM_DELETED:"itemDeleted",
   ITEM_UPDATED:"itemUpdated",
   ITEM_PERM_DELETED:'itemPermDeleted',
   ITEM_RESTORED:'itemRestored',
   SEND_MAIL:'mailSend',
   FAILED_CREATION_PDF:'failedCreationPdf'
  }

  @action.bound handleOpen (msg) {
    this.currentMessage = msg
    this.open = true
  }

  @action.bound handleClose () {
    this.open = false
  }

}



// WEBPACK FOOTER //
// ./src/stores/messenger.js